<template>
  <div class="h-screen w-screen overflow-hidden bg-[#fdfbf7] flex flex-col relative font-sans">
    <!-- Background Decoration -->
    <div class="absolute inset-0 pointer-events-none z-0 opacity-10">
      <div class="absolute top-0 right-0 w-96 h-96 bg-green-800 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
      <div class="absolute bottom-0 left-0 w-96 h-96 bg-amber-800 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>
    </div>

    <!-- Header with Logo -->
    <header class="w-full py-8 pt-40 flex justify-center z-10">
      <img src="@/assets/logo.png" alt="Logo" class="h-16 w-auto" />
    </header>

    <!-- Main Content -->
    <main class="flex flex-col items-center justify-center z-10 pb-20">
      <div class="text-center mb-16 space-y-4">
        <h1 class="text-4xl md:text-5xl font-bold text-amber-800 tracking-wider">
          中医智能问诊
        </h1>
        <p class="text-xl text-amber-600 font-light tracking-widest">
          精准辨证 · 问答之间
        </p>
      </div>

      <div class="flex flex-col md:flex-row gap-8 md:gap-16 w-full max-w-4xl justify-center px-6">
        <!-- Patient Button -->
        <button 
          @click="handle_patient_click"
          class="group relative flex flex-col items-center justify-center p-8 bg-white border-2 border-amber-100 rounded-2xl shadow-lg hover:shadow-xl hover:border-amber-300 transition-all duration-300 w-full md:w-64"
        >
          <div class="w-16 h-16 mb-4 rounded-full bg-amber-50 flex items-center justify-center group-hover:bg-amber-100 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-amber-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <span class="text-xl font-medium text-gray-800 group-hover:text-amber-800">我是用户</span>
          <span class="mt-2 text-sm text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity">开启健康咨询</span>
        </button>

        <!-- Doctor Button -->
        <button 
          @click="handle_doctor_click"
          class="group relative flex flex-col items-center justify-center p-8 bg-white border-2 border-emerald-100 rounded-2xl shadow-lg hover:shadow-xl hover:border-emerald-300 transition-all duration-300 w-full md:w-64"
        >
          <div class="w-16 h-16 mb-4 rounded-full bg-emerald-50 flex items-center justify-center group-hover:bg-emerald-100 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-emerald-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.384-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
            </svg>
          </div>
          <span class="text-xl font-medium text-gray-800 group-hover:text-emerald-800">我是机构</span>
          <span class="mt-2 text-sm text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity">进入工作台</span>
        </button>
      </div>
    </main>

    <!-- Footer Decoration -->
    <footer class="absolute bottom-0 w-full py-4 text-center text-gray-400 text-xs z-10">
      <p>© 2026 大用问症 | 传承 · 创新 · 普惠</p>
    </footer>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'HomeView',
  setup() {
    const router = useRouter()

    const handle_patient_click = () => {
      router.push('/patient')
    }

    const handle_doctor_click = () => {
      // 检查本地是否有token
      const token = localStorage.getItem('token')
      if (token) {
        // 有token，跳转到专科问诊页面
        // 注意：路由路径可能需要根据 router/index.js 的修改进行调整
        // 假设我们修改后的路径是 /doctor/specialized
        router.push('/doctor/specialized')
      } else {
        // 无token，跳转到机构登录页
        router.push('/login')
      }
    }

    return {
      handle_patient_click,
      handle_doctor_click
    }
  }
}
</script>

<style scoped>
/* 可以添加额外的自定义样式 */
</style>
